import type { WizardStep } from './types';
import { WIZARD_STEPS } from './constants';

export interface SequenceOptions {
  /** Visitor is in the FAST_PATH_WIZARD 'fast' arm. */
  fastPath: boolean;
  /** isAppearancePrefillConfident(characters) after the photo analysis. */
  appearanceConfident: boolean;
  /** Continuing a ready free cover whose image becomes the book cover (Task 8). */
  fromCoverReuse: boolean;
  /** Every character has age, gender and looks. Defaults true; false falls back to the full steps (safety net). */
  traitsComplete?: boolean;
}

/** The multi-character step order for this visitor. Control is exactly WIZARD_STEPS.multi. */
export function buildMultiStepSequence({ fastPath, appearanceConfident, fromCoverReuse, traitsComplete = true }: SequenceOptions): WizardStep[] {
  if (!fastPath || !traitsComplete) return [...WIZARD_STEPS.multi];
  const steps: WizardStep[] = ['story-type', 'photo-upload'];
  if (!(fromCoverReuse && appearanceConfident)) steps.push('multi-character-details');
  if (!appearanceConfident) steps.push('multi-character-appearance');
  if (!fromCoverReuse) steps.push('style'); // the reused cover fixes the style (Realistic)
  steps.push('story-creation', 'story-preview');
  return steps;
}

/** The step after `current` in `steps`, or `current` when it is last or not in the list. */
export function nextStepAfter(steps: WizardStep[], current: WizardStep): WizardStep {
  const i = steps.indexOf(current);
  return i >= 0 && i < steps.length - 1 ? steps[i + 1] : current;
}
